// src/services/scheduleService.js
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const getAuthHeader = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('access_token')}`
  }
});

export const scheduleService = {
  // Récupérer les événements
  getEvents: async (startDate, endDate, filters = {}) => {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    if (filters.staff_id) params.append('staff_id', filters.staff_id);
    if (filters.event_type) params.append('event_type', filters.event_type);
    
    const response = await axios.get(`${API_BASE}/schedule/events?${params}`, getAuthHeader());
    return response.data;
  },

  // Créer un événement
  createEvent: async (eventData) => {
    const response = await axios.post(`${API_BASE}/schedule/events`, eventData, getAuthHeader());
    return response.data;
  },

  // Mettre à jour un événement
  updateEvent: async (eventId, eventData) => {
    const response = await axios.put(`${API_BASE}/schedule/events/${eventId}`, eventData, getAuthHeader());
    return response.data;
  },

  // Supprimer un événement
  deleteEvent: async (eventId) => {
    const response = await axios.delete(`${API_BASE}/schedule/events/${eventId}`, getAuthHeader());
    return response.data;
  }
};